import { useFrame, useThree } from "@react-three/fiber";
import * as THREE from "three";

// TEMPORARY dev tool — remove once waypoint authoring is done.
// Tracks the live camera position + a look-ahead "target" point every frame
// so the two copy buttons (rendered outside the Canvas) always grab the
// latest values on click.
export const liveCamDebug = { cam: [0, 0, 0], target: [0, 0, 0] };

const dir = new THREE.Vector3();
const targetPoint = new THREE.Vector3();

export function DebugCamTracker() {
  const camera = useThree((state) => state.camera);
  useFrame(() => {
    liveCamDebug.cam = [camera.position.x, camera.position.y, camera.position.z];
    camera.getWorldDirection(dir);
    targetPoint.copy(camera.position).addScaledVector(dir, 50);
    liveCamDebug.target = [targetPoint.x, targetPoint.y, targetPoint.z];
  });
  return null;
}

const formatVec = ([x, y, z]) =>
  `[${x.toFixed(4)}, ${y.toFixed(4)}, ${z.toFixed(4)}]`;

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Clipboard API needs a secure context — fails on plain-HTTP LAN testing
    // (e.g. phone hitting http://192.168.x.x:5173). Fall back to a manual-copy prompt.
    window.prompt("Copy this value:", text);
    return false;
  }
};

export const copyCamPosition = () => copyText(formatVec(liveCamDebug.cam));
export const copyTargetPosition = () => copyText(formatVec(liveCamDebug.target));
